module.exports = __webpack_public_path__ + "static/img/slide-4.894ce9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-4.jpg
// module id = Qo+Y
// module chunks = 1